import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import * as api from "../api";
import { useAuth } from "../auth";

export default function ChangePasswordPage() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.changePassword(current, next);
      const u = await api.me();
      setUser(u);
      toast.success("Password updated");
      nav(u.is_admin ? "/admin" : "/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-[var(--canvas)] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
        <h1 className="font-display text-2xl font-semibold mb-1">Set a new password</h1>
        <p className="text-sm text-slate-500 mb-6">
          {user?.must_change_password
            ? "First-login: please change the initial password."
            : "Update your account password."}
        </p>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Current password" type="password" value={current} onChange={setCurrent} testid="cp-current" />
          <Field label="New password (min 10 chars)" type="password" value={next} onChange={setNext} testid="cp-new" minLength={10} />
          <button type="submit" disabled={busy}
                  data-testid="cp-submit-btn"
                  className="w-full bg-[#C5283F] text-white rounded-lg py-3 font-medium hover:bg-[#A82035] disabled:opacity-50">
            {busy ? "Saving…" : "Update password"}
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, type = "text", value, onChange, testid, minLength }) {
  return (
    <div>
      <label className="text-[11px] uppercase tracking-wider text-slate-600 font-semibold block mb-1.5">{label}</label>
      <input type={type} value={value} onChange={(e) => onChange(e.target.value)}
             data-testid={testid} required
             minLength={minLength}
             className="w-full px-3 py-2.5 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#C5283F] focus:border-transparent" />
    </div>
  );
}
